const TEAM_SIDES = {
  HOME: 'home',
  AWAY: 'away',
};
export const MATCH_STATUSES = {
  FINISHED: 'finished',
  UPCOMING: 'upcoming',
};
const API_STATUSES = {
  FINISHED: 'finished',
};
function getTeamData(matchInput, teamSide) {
  const teamName = matchInput[`${ teamSide}_nick`];
  const teamLogo = matchInput[`${ teamSide}_logo`];
  return {
    name: teamName,
    image: teamLogo,
  };
}
function getMatchDate(matchData){
  const { start_time: epochTime, } = matchData;
  return new Date(1000 * epochTime);
}
function getMatchStatus(matchData){
  return matchData.status === API_STATUSES.FINISHED ? MATCH_STATUSES.FINISHED : MATCH_STATUSES.UPCOMING;
}
function getMatchResult(matchData){
  const { match_score: score, } = matchData;
  const { home_team: home, away_team: away, } = score;
  return {
    home,
    away,
  };
}
export function transformMatchResponse(serverMatch){
  const clientMatch = {
    homeTeam: getTeamData(serverMatch, TEAM_SIDES.HOME),
    awayTeam: getTeamData(serverMatch, TEAM_SIDES.AWAY),
    result: getMatchResult(serverMatch),
    date: getMatchDate(serverMatch),
    status: getMatchStatus(serverMatch),
  };
  return clientMatch;
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/schedule/matchTransformUtil.js